'use client'
import { useState, useEffect } from 'react';
import { initTournament, getSavedTournament } from '@/components/utils/apiHelper';

/**
 * Hook to initialize and return the active tournament ID.
 * Reads from localStorage for instant render, then refreshes from Supabase.
 */
export function useTournament() {
  const [tournamentId, setTournamentId] = useState(() => {
    if (typeof window !== 'undefined') {
      return getSavedTournament();
    }
    return null;
  });

  useEffect(() => {
    const init = async () => {
      const cached = getSavedTournament();
      if (cached) setTournamentId(cached);

      const tournament = await initTournament();
      if (tournament) setTournamentId(tournament.id);
    };
    init();
  }, []);

  return tournamentId;
}
